"use strict";

PF.Field.String = class String extends PF.Field
	{
	static get options()
		{
		return {
			dom: {
				element: undefined,
				wrapper: undefined,
				leading: undefined,
				trailing: undefined,
			},
			html: PF.Field.String.templates,
			type: "text",
			label: "",
			helper: "",
			showInfo: true,

			minLength: 0,
			maxLength: Infinity,
			fixLength: undefined,
			regexp: undefined,
			errors: {
				minLength: (c) => `Значение должно сосотять не менее чем из ${Util.spell(c.minLength, ['', '@{v} символа', '@{v} символов', '@{v} символов'])}`,
				maxLength: (c) => `Значение должно сосотять не более чем из ${Util.spell(c.maxLength, ['', '@{v} символа', '@{v} символов', '@{v} символов'])}`,
				fixLength: (c) => `Значение должно сосотять из ${Util.spell(c.fixLength, ['', '@{v} символа', '@{v} символов', '@{v} символов'])}`,
				regexp: 'Значение не корректно'
			},

			audioLabels: '',
			speech: app.speech,
		};
		}

	static get templates()
		{
		return {
			//language=HTML
			wrapper: `
				<div class="pf-string-wrapper">
					<div class="innerBlock" pf="innerBlock">
						<div class="leadingBlock" pf="leadingBlock"></div>
						<div class="center" pf="center">
							<label pf="label"></label>
							<input type="text" pf="input"/>
						</div>
						<div class=trailingBlock pf="trailingBlock"></div>
					</div>
					<div class="underline">
						<hr class="normal"/>
						<hr class="focus"/>
					</div>
					<div class="info" pf="info">&nbsp</div>
				</div>
			`,
		};
		}

	init()
		{
		this.dom.loads(this.html);

		this.dom.element.after(this.dom.wrapper);
		this.dom.input.after(this.dom.element);
		this.dom.input.remove();
		this.dom.input = this.dom.element;
		this.dom.wrapper.bindAll();
		this.dom.element.addClass('pf-string');
		this.dom.wrapper.classes.small = this.dom.element.classes.small;

		this.bindDom({leadingBlock: 'show'}, [], () => this.dom.leading !== undefined);
		this.dom.leadingBlock.append(this.dom.leading);
		this.bindDom({trailingBlock: 'show'}, [], () => this.dom.trailing !== undefined);
		this.dom.trailingBlock.append(this.dom.trailing);

		this.dom.input.bindAll();

		if (this.dom.input.attributes.placeholder !== undefined && this.dom.input.attributes.placeholder !== '')
			{
			this.label = this.dom.input.attributes.placeholder;
			this.dom.input.attributes.placeholder = '';
			}

		this.bindDom({wrapper: 'class:active'}, ['dom.input.focus', 'dom.input.value'], (focus, value) => focus || value !== '');
		this.bindDom({wrapper: 'class:error'}, ['error'], (error) => error !== '');
		this.bindDom({wrapper: 'class:focus'}, 'dom.input.focus');
		this.bindDom({info: 'html'}, ['helper', 'error', 'dom.input.focus'], (helper, error, focus) => error !== '' ? error : helper !== '' && focus ? helper : '&nbsp;');
		this.bindDom({info: 'show'}, 'showInfo');
		this.bindDom({label: 'text'}, 'label');

		this.bindInput();
		}

	destroy()
		{
		app.speechRemoveWidget(this);
		super.destroy();
		}

	bindInput()
		{
		this.model.onChange(this.key, () => {
			this.dom.input.value = this.calcDisplayValue(this.model.get(this.key, '', ''));
			this.validate(true);
		}, true);
		this.on('dom.input.change:value', () => {
			this.dom.input.value = this.mediateDisplayValue(this.dom.input.value);
			this.model.setData(this.key, this.calcRealValue(this.dom.input.value));
		});
		}

	setFocus()
		{
		this.dom.input.node.focus();
		}

	mediateDisplayValue(displayValue)
		{
		return displayValue;
		}

	calcDisplayValue(realValue)
		{
		return realValue;
		}

	calcRealValue(displayValue)
		{
		return displayValue;
		}

	validate(silent, error, breakByChildError = false)
		{
		if (breakByChildError === true && error !== undefined)
			{
			return super.validate(silent, error);
			}

		let value = this.model.get(this.key, null, null, (v) => v + '');
		if (this.required)
			{
			if (value === null || value.length === 0)
				{
				return super.validate(silent, this.errors.required);
				}
			}

		if (this.regexp !== undefined)
			{
			if (this.regexp.test(value) === false)
				{
				return super.validate(silent, this.errors.regexp);
				}
			}

		if (value !== null)
			{
			if (this.fixLen !== undefined)
				{
				if (value.length !== this.fixLen)
					{
					return super.validate(silent, this.errors.fixLen);
					}
				}
			if (value.length < this.minLen)
				{
				return super.validate(silent, this.errors.minLen);
				}
			if (value.length > this.maxLen)
				{
				return super.validate(silent, this.errors.maxLen);
				}
			}


		return super.validate(silent, error);
		}
	};


